var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('el-empty',{attrs:{"image-size":200,"description":"功能暂未开放"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }